export default "__VITE_ASSET__DgYfOcPm__"